/** What people see: "v0.2.0 alpha", or just "v1.0.0" once there is no stage. */
export function formatAppVersion(
  version: string | undefined,
  stage: string | undefined,
): string | null {
  if (version === undefined || version === "") {
    return null;
  }
  return stage === undefined || stage === "" ? `v${version}` : `v${version} ${stage}`;
}
